
import { cn } from "@/lib/utils";
import AnimatedCard from "./AnimatedCard";

interface TestimonialProps {
  quote: string;
  author: string;
  position: string;
  className?: string;
  delay?: number;
}

export const Testimonial = ({
  quote,
  author,
  position,
  className,
  delay = 0,
}: TestimonialProps) => {
  return (
    <AnimatedCard 
      delay={delay} 
      className={cn("p-6 backdrop-blur-lg bg-black/20 border border-white/20 rounded-2xl shadow-lg", className)}
    >
      <div className="flex flex-col h-full text-center">
        <div className="text-xl text-white/90 italic mb-4 flex-1">
          "{quote}"
        </div>
        <div className="mt-auto">
          <p className="font-semibold text-white">{author}</p>
          <p className="text-white/60 text-sm">{position}</p>
        </div>
      </div>
    </AnimatedCard>
  );
};

export default Testimonial;
